<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code" :sub_guide="sub_data_contents_information">
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->
           
            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력" />    
            </template>
            
            <div class="mt-3 mb-1 fw-600 f-90"> Sub type </div>            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                        :key="`subs-textbox-subtype-opt-${sub_type}-${sub_type_idx}`"
                        @click="selectType(sub_type)"
                        >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>

                <b-form-input v-model="sub_name" placeholder="Title (필요시 작성)">
                    {{ sub_name }}
                </b-form-input>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"> {{ sub_description }} </b-textarea>

            <div class="mt-3 mb-1 fw-600 f-90">Info</div>
            <b-textarea v-model="sub_info" placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보" > {{ sub_info }} </b-textarea>

            <div class="mt-3 mb-1 fw-600 f-90" style="cursor:pointer" @click="conditionPopoverToggle()">Condition <fa :id="`sub_condition_information+${sub_code}`" icon="info-circle"></fa></div>
            <b-popover :target="`sub_condition_information+${sub_code}`" title="설명" :content="sub_condition_information" placement="left" :show="sub_condition_popover_show"></b-popover>
            <div  id="editing-template-condition">
                <b-form-checkbox v-model="is_condition_available" @input="manageConditionAvailability()" class="editing-dfs">
                    <b-form-input placeholder="선행조건 표시내용을 입력해 주세요" v-model="sub_condition.text"> {{ sub_condition.text }} </b-form-input>
                </b-form-checkbox>      
            </div>
        </template>

        <template #structure>
            <div class="d-flex editing-dfs">
                <b-form-input v-model="sub_data_contents.placeholder" placeholder="텍스트박스 입력 가이드를 입력해주세요" class="w-75">{{ sub_data_contents.placecholder }}</b-form-input>
                <b-form-input v-model="sub_data_header.rows" placeholder="박스크기(rows)" type="number" class="ml-2 w-25">{{ sub_data_header.rows }}</b-form-input>
            </div>
        </template>


        <template #option>
            <!-- Tags, Child 등 기본 공통 -->

            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부문항"
                        :label-for="`editing-subs-textbox-${sub_code}-has_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-textbox-${sub_code}-has_attachment`"
                            v-model="has_attachment"
                            >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>
                
                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부필수"
                        :label-for="`editing-subs-textbox-${sub_code}-required_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-textbox-${sub_code}-required_attachment`"
                            v-model="required_attachment"
                            :disabled="!has_attachment"
                            >
                            첨부필수 문항
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-textbox-${sub_code}-risk`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-textbox-${sub_code}-risk`"
                            v-model="sub_risk"
                            >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Priority"
                        :label-for="`editing-subs-textbox-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >

                        <b-form-select :id="`editing-subs-textbox-${sub_code}-tags`"
                            v-model="sub_priority"
                            :options="sub_priority_option"
                            />
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Child"
                        :label-for="`editing-subs-textbox-${sub_code}-child`"
                        class="align-items-center mb-0"
                        >

                        <b-form-checkbox :id="`editing-subs-textbox-${sub_code}-child`"
                            v-model="has_child"
                            @change="handleHasChild"
                            >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-textbox-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >
                        <b-input :id="`editing-subs-textbox-${sub_code}-tags`" v-model="tags"
                            placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                            />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>

            <!-- <div class="d-flex mb-3">
                <div class="fw-600 f-90 mr-5">Not Applicable</div>
                <b-form-checkbox v-model="sub_data_header.enable_na" class="blue">선택지에 '해당없음' 추가</b-form-checkbox>
            </div> -->

            <!-- <div class="d-flex mb-3">
                <span class="fw-600 mr-5 f-90">Tags </span>
                <b-input v-model="tags" placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"> {{ tags }}</b-input>
            </div> -->

            <!-- <div v-if="checkAbleChild" class="d-flex mb-3">
                <span class="fw-600 mr-5 f-90">Child</span>
                <div class="bgray-200 w-100 p-2 rounded">
                    <b-form-checkbox v-model="has_child" @change="handleHasChild">파일 및 URL 첨부</b-form-checkbox>
                </div>
            </div> -->

            <!-- <div class="d-flex mb-3">
                <span class="fw-600 mr-5 f-90">첨부</span>
                <div class="bgray-200 w-100 p-2 rounded ">
                    <b-form-checkbox v-model="sub_data_header.has_attachment">파일 및 URL 첨부</b-form-checkbox>
                </div>
            </div> -->

            <!-- <div class="d-flex mb-3">
                <span class="fw-600 mr-5 f-90"> Risk </span>
                <div class="bgray-200 w-100 p-2 rounded">
                    <b-form-checkbox v-model="sub_risk"> 적용 </b-form-checkbox>
                </div>
            </div> -->

            <!-- <div class="d-flex mb-3">
                <span class="fw-600 mr-5 f-90">Priority</span>
                <b-form-select v-model="sub_priority" :options="sub_priority_option"></b-form-select>
            </div> -->
        </template>
        
        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                    @click="handleSaveSub"
                    :disabled="is_saving_subs"
                    >
                    <div class="d-flex align-items-center">
                        저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                    </div>
                </b-button>
                <b-button @click="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import { EditingSubComponentMixin } from '@core_mixins/EditingSubComponentMixin'

export default {
    name: 'editing-df-textbox',
    mixins: [EditingSubComponentMixin],
    data() {
        return {
            sub_data_contents_information: `
                placeholder: 텍스트박스 입력 폼에 표시될 가이드 텍스트입니다. 
                rows: 텍스트박스의 높이(화면에 표기될 줄 수)입니다.
            `
        }
    },
    methods: {
        async handleSaveSub () {
            await this.saveSub()
            this.$emit('click-save')
        }
    }
}
</script>
